import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./MiddleSection.css";
import "../../assets/css/mobile.css";
import MouldPlate from "../MouldPlate/MouldPlate";
import SmileGallery from "../SmileGallery/SmileGallery";
import FaceMeasure from "../../pages/Measure/FaceMeasure";
import { Select } from "antd";

const { Option } = Select;

const TIP_DISMISSED_KEY = "toothMouldTipDismissed";

const MiddleSection = () => {
  const [dropData, setDropData] = useState({});
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [mass, setMass] = useState("");
  const [color, setColor] = useState([]);
  const [shape, setShape] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [alphaCode, setAlphaCode] = useState("");
  const [activeTab, setActiveTab] = useState("search");
  const [measureOpen, setMeasureOpen] = useState(false);
  const [showTip, setShowTip] = useState(
    () => localStorage.getItem(TIP_DISMISSED_KEY) !== "true"
  );

  const [teethCase, setTeethCase] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("userToken");

  const dismissTip = () => {
    localStorage.setItem(TIP_DISMISSED_KEY, "true");
    setShowTip(false);
  };

  const loadDropdowns = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/auth/v1/dropdowns`
      );
      const dropdownData = response.data;
      setDropData(dropdownData);
    } catch (error) {
      console.error("Error loading dropdowns:", error);
      throw error;
    }
  };

  useEffect(() => {
    loadDropdowns();
  }, []);

  const handleSearch = async () => {
    if (token) {
      const selectedFilters = {
        width: width || undefined,
        height: height || undefined,
        mass: mass || undefined,
        color: color.length > 0 ? JSON.stringify(color) : undefined,
        shape: shape.length > 0 ? JSON.stringify(shape) : undefined,
        vendor: vendor.length > 0 ? JSON.stringify(vendor) : undefined,
        teethCase: teethCase.length > 0 ? JSON.stringify(teethCase) : undefined,
        alphaCode: alphaCode || undefined,
      };

      const queryParams = new URLSearchParams();

      for (const [key, value] of Object.entries(selectedFilters)) {
        if (value !== undefined) {
          queryParams.append(key, value);
        }
      }

      navigate(`/product-results?${queryParams.toString()}`);
    } else {
      navigate(`/`);
    }
  };

  // Function to check if any filters are selected
  const isAnyFilterSelected = () => {
    return (
      mass ||
      width ||
      height ||
      color.length > 0 ||
      shape.length > 0 ||
      vendor.length > 0 ||
      teethCase.length > 0 ||
      alphaCode.length > 0
    );
  };

  return (
    <div className="hero-container">
      <div className="cd-container">
        <div className="cd-left">
          <h2>Find the mould by its measurements.</h2>
          <p className="cd-lede">
            Every mould in the catalogue, indexed by width, height, mass,
            shape and case &mdash; searchable by the numbers you already have
            in front of you.
          </p>
          {/* The mock framed its diagram in a bordered panel with corner
              markers. The plate already draws its own registration marks, so
              this is the panel without a second set of corners on top. */}
          <div className="plate-panel">
            <MouldPlate />
          </div>
        </div>
        <div className="cd-right">
          <div className="smile-search-container">
            <span className="secondary-container">
              <h1>Find The Best Smile</h1>
              <div className="tabs">
                <div
                  className="tab-indicator"
                  style={{
                    transform:
                      activeTab === "search"
                        ? "translateX(0%)"
                        : "translateX(100%)",
                  }}
                />
                <button
                  type="button"
                  className={`tab-item ${
                    activeTab === "search" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("search")}
                >
                  Search By Data
                </button>
                <button
                  type="button"
                  className={`tab-item ${
                    activeTab === "measure" ? "active" : ""
                  }`}
                  onClick={() => setMeasureOpen(true)}
                >
                  Measure via Face Scan
                </button>
              </div>

              <div className="teeth-size teeth-weight">
                <label className="input-label" htmlFor="mould-number-input">
                  Tooth Mould
                </label>
                <div className="field-anchor">
                  <div className="input-group-2">
                    <input
                      id="mould-number-input"
                      type="text"
                      placeholder="Mould Number"
                      className="custom-box"
                      value={alphaCode}
                      onChange={(e) => setAlphaCode(e.target.value)}
                      aria-describedby={
                        showTip ? "mould-number-tip" : undefined
                      }
                    />
                  </div>
                  {showTip && (
                    <div
                      className="field-tooltip"
                      id="mould-number-tip"
                      role="tooltip"
                    >
                      <button
                        type="button"
                        className="field-tooltip-close"
                        onClick={dismissTip}
                        aria-label="Dismiss tip"
                      >
                        &times;
                      </button>
                      <p>
                        Start here. Enter a mould number for an exact match,
                        or scroll down to search by size and filters instead.
                      </p>
                    </div>
                  )}
                </div>

                <label className="input-label">Tooth size</label>
                <div className="input-group-2">
                  <input
                    type="text"
                    placeholder="6 Anterior Width"
                    className="custom-box"
                    value={mass}
                    onChange={(e) => setMass(e.target.value)}
                  />
                </div>
              </div>

              <div className="teeth-size">
                <div className="input-group-2">
                  <input
                    type="text"
                    placeholder="Width"
                    value={width}
                    onChange={(e) => setWidth(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Height"
                    className="custom-box"
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                  />
                </div>
              </div>
              <div className="filters">
                <label className="input-label">Filters</label>
                <div className="filter-group">
                  {/* <Select
                    mode="multiple"
                    value={color.length > 0 ? color : []}
                    onChange={(value) => setColor(value)}
                    placeholder="Select Color"
                    style={{ width: "100%" }}
                    className="multi-select"
                  >
                    {dropData?.Colors?.map((m) => (
                      <Option key={m?.name} value={m?.name}>
                        {m?.name}
                      </Option>
                    ))}
                  </Select> */}

                  <Select
                    mode="multiple"
                    value={shape}
                    onChange={(value) => setShape(value)}
                    placeholder="Select Shape"
                    style={{ width: "100%" }}
                  >
                    {dropData?.Shapes?.map((m) => (
                      <Option key={m?.name} value={m?.name}>
                        {m?.name}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="filter-group">
                  <Select
                    mode="multiple"
                    value={vendor}
                    onChange={(value) => setVendor(value)}
                    placeholder="Select Manufacturer"
                    style={{ width: "100%" }}
                  >
                    {dropData?.Vendors?.map((m) => (
                      <Option key={m?.name} value={m?.name}>
                        {m?.name}
                      </Option>
                    ))}
                  </Select>

                  <Select
                    mode="multiple"
                    value={teethCase}
                    onChange={(value) => setTeethCase(value)}
                    placeholder="Select Case"
                    style={{ width: "100%" }}
                  >
                    {dropData?.Cases?.map((m) => (
                      <Option key={m?.name} value={m?.name}>
                        {m?.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              <button
                className="search-btn"
                onClick={handleSearch}
                disabled={!isAnyFilterSelected()}
              >
                {/* Drawn rather than pulled from an icon font: the reference
                    mock used Material Symbols, which is a second webfont
                    request for one glyph. */}
                <svg
                  viewBox="0 0 16 16"
                  width="15"
                  height="15"
                  aria-hidden="true"
                  focusable="false"
                >
                  <circle
                    cx="7"
                    cy="7"
                    r="4.6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                  <path
                    d="m10.4 10.4 3.1 3.1"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                  />
                </svg>
                Search catalogue
              </button>
            </span>
          </div>
        </div>
      </div>
      {/* <div className="section">
        <div className="users">
          <img loading="lazy" src={Users} alt="users" />
        </div>
      </div> */}

      {/* <div className="section">
        <div className="auto-slider">
          <h2>Our Partners</h2>
        </div>
      </div> */}

      {/* Face scan runs in a modal rather than its own route, so the user
          keeps the search card and their entered filters behind it. */}
      <SmileGallery />

      <FaceMeasure
        asModal
        open={measureOpen}
        onClose={() => setMeasureOpen(false)}
      />
    </div>
  );
};

export default MiddleSection;
